import { formatUGX } from '../api/getProducts';

export function OrderSummary({ items }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-card p-5">
      <h2 className="mb-4 text-sm font-extrabold uppercase tracking-wide text-text-muted">
        Order summary
      </h2>

      <div className="flex flex-col gap-3">
        {items.map((item) => (
          <div key={item.id} className="flex items-center gap-3">
            <img
              src={item.img}
              alt={item.name}
              className="h-12 w-12 shrink-0 rounded-lg object-cover"
            />
            <div className="min-w-0 flex-1">
              <div className="truncate text-sm font-bold">{item.name}</div>
              <div className="text-xs text-text-dim">Qty {item.qty}</div>
            </div>
            <div className="shrink-0 text-sm font-bold text-text">
              UGX {formatUGX(item.price * item.qty)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
